module.exports = __webpack_public_path__ + "static/media/c3bannerModulE_small.8ab7cffd.jpg";